/**
 * @generated SignedSource<<c336c865db76b6208ffd7fc4b6b48456>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AlertsMenuItemContent$data = {
  readonly opsgenie: {
    readonly savedSearches: {
      readonly createdByMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
      readonly sharedWithMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
      readonly starred: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
    };
  };
  readonly " $fragmentType": "AlertsMenuItemContent";
} | null;
export type AlertsMenuItemContent$key = {
  readonly " $data"?: AlertsMenuItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertsMenuItemContent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "id"
    },
    "action": "THROW"
  },
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "name"
    },
    "action": "THROW"
  },
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "alertSearchQuery"
    },
    "action": "THROW"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "AlertsMenuItemContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "OpsgenieSavedSearches",
              "kind": "LinkedField",
              "name": "savedSearches",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "starred",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "sharedWithMe",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "createdByMe",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "LOG"
                }
              ]
            },
            "action": "LOG"
          }
        ]
      },
      "action": "LOG"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "8fd09387c46253d01b80dce6b0b047b9";

export default node;
